"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
exports.default = satcheljs_1.mutatorAction('setRenameFoldersOption', function setRenameFoldersOption(shouldRenameFolders) {
    store_1.default().shouldRenameDefaultFolders = shouldRenameFolders;
});
//# sourceMappingURL=setRenameFoldersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/setRenameFoldersOption.js
// module id = 4935
// module chunks = 2